import React, { useState } from "react";
import { FaPlus, FaTimes } from "react-icons/fa";
import AddTopicForm from "./AddTopicForm";
import TopicItem from "./TopicItem";

const TopicList = ({ topics }) => {
  const [addTopicForm, setAddTopicForm] = useState(false);
  const handleAddTopic = () => {
    setAddTopicForm((prev) => !prev);
  };

  return (
    <section className="bg-primary flex flex-col gap-4 w-full sm:p-7 p-2 rounded-[4px] border border-adminMainBorder">
      {/* Upper Section */}
      <div className="flex flex-row w-full justify-between items-center">
        {/* Upper Section header */}
        <h2 className="text-textPrimary text-[18px] font-semibold">
          Topic List
        </h2>

        {/* Button to add topic */}
        <button
          type="button"
          onClick={handleAddTopic}
          className="border-adminRightTextPrimary border sm:w-[180px] w-[50px] sm:h-[32px] h-[28px] rounded-[4px] text-adminRightTextPrimary "
        >
          {/*  Change the button status based on click*/}
          <div className="flex gap-3 justify-center items-center">
            {addTopicForm ? <FaTimes /> : <FaPlus />}
            <span className="sm:block hidden">
              {addTopicForm ? "Close" : "Add Topic"}
            </span>
          </div>
        </button>
      </div>

      {/* Show add topic form when button is clicked */}
      {addTopicForm ? <AddTopicForm /> : null}
      <div>
        {topics?.length === 0 ? (
          <div className="row-span-full text-center">
            <span className="text-center">No topic found</span>
          </div>
        ) : (
          topics?.map((topic) => <TopicItem key={topic?._id} topic={topic} />)
        )}
      </div>
    </section>
  );
};

export default TopicList;
